export const requestUUID = (): string => {
  const el: HTMLElement = document.querySelector("meta[name='request-uuid']")
  return el.getAttribute('content')
}
